// 直接定義して shared 依存を解決
export enum UserRole {
  STUDENT = 'student',
  ADMIN = 'admin',
  COMPANY_ADMIN = 'company_admin',
  HR = 'hr',
  EMPLOYEE = 'employee',
}

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  SUSPENDED = 'suspended',
}

export interface User {
  id: number;
  email: string;
  fullName: string;
  userRole: UserRole;
  isVerified: boolean;
  status: UserStatus;
  createdAt: string;
  updatedAt: string;
  bio?: string;
  phone?: string;
  organization?: string;
  avatarUrl?: string;
  lastLoginAt?: string;
}

export interface UserRegistration {
  email: string;
  password: string;
  fullName: string;
  userRole?: UserRole;
  furigana?: string;
  university?: string;
  faculty?: string;
  phone?: string;
  birthDate?: string;
  gender?: string;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface AuthResponse {
  user: User;
  token: string;
  refreshToken: string;
}

export interface LoginFormData {
  email: string;
  password: string;
  rememberMe?: boolean;
}

export interface RegisterFormData {
  fullName: string;
  furigana: string;
  university: string;
  faculty: string;
  phone: string;
  birthDate: string;
  gender: string;
  email: string;
  password: string;
  confirmPassword: string;
  agreeToTerms: boolean;
}

export interface ForgotPasswordFormData {
  email: string;
}

export interface ResetPasswordFormData {
  password: string;
  confirmPassword: string;
  token: string;
}

export interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

export interface AuthContextType extends AuthState {
  login: (credentials: LoginCredentials, rememberMe?: boolean) => Promise<void>;
  register: (userData: UserRegistration) => Promise<void>;
  logout: () => void;
  resetPassword: (email: string) => Promise<void>;
  confirmPasswordReset: (token: string, password: string) => Promise<void>;
  clearError: () => void;
  refreshToken: () => Promise<void>;
}

export interface PasswordStrength {
  score: number; // 0-4
  label: 'weak' | 'fair' | 'good' | 'strong';
  feedback: string[];
}

export interface ValidationErrors {
  [key: string]: string | undefined;
}

export interface ChangeEmailRequest {
  currentPassword: string;
  newEmail: string;
}

export interface ChangeEmailResponse {
  success: boolean;
  data: {
    message: string;
    newEmail: string;
  };
}

// 型は上で直接定義済み
